// extracted by mini-css-extract-plugin
module.exports = {"wr_spinner":"_2hjOSJSH1OX60WA6t84UFZ"};